/**
 * Preferências de filtro do Kanban, guardadas por usuário.
 *
 * As chaves antigas eram GLOBAIS (uma por navegador, não por conta) e vazavam
 * entre contas na mesma máquina: quem logasse depois herdava o filtro de
 * responsável de quem logou antes e via o quadro vazio, sem erro nenhum na tela
 * — o filtro vai para o servidor como `.in('responsavel_id', [...])`.
 *
 * Mesma correção já aplicada ao funil ativo em `pipelines.ts`: a chave legada é
 * DESCARTADA, nunca adotada. Adotá-la seria atribuir a escolha de um usuário a
 * quem logar primeiro naquele navegador. Custa uma reconfiguração de filtro e
 * auto-cura os aparelhos já afetados no primeiro carregamento.
 */

const CHAVES_LEGADAS = [
    'vigorhub_kanban_selected_responsibles',
    'vigorhub_kanban_complex_filters',
] as const;

export const chaveResponsaveis = (userId: string) => `vigorhub_kanban_selected_responsibles_${userId}`;
export const chaveFiltrosComplexos = (userId: string) => `vigorhub_kanban_complex_filters_${userId}`;

/** Roda no primeiro acesso ao storage do Kanban: apaga o resíduo global. */
export const limparChavesLegadas = () => {
    try {
        CHAVES_LEGADAS.forEach(k => localStorage.removeItem(k));
    } catch { /* modo privado / storage indisponível */ }
};

/** `null` = nada salvo para este usuário (o chamador aplica o padrão por papel). */
export const lerPref = <T,>(chave: string | null): T | null => {
    limparChavesLegadas();
    if (!chave) return null;
    try {
        const salvo = localStorage.getItem(chave);
        return salvo ? (JSON.parse(salvo) as T) : null;
    } catch {
        return null; // storage indisponível ou JSON corrompido
    }
};

export const gravarPref = (chave: string | null, valor: unknown) => {
    if (!chave) return;
    try {
        localStorage.setItem(chave, JSON.stringify(valor));
    } catch { /* preferência de UI não vale quebrar o fluxo */ }
};
